import bonus1Image from 'assets/images/wellness-download-bonus-1-image.webp'
import bonus2Image from 'assets/images/wellness-download-bonus-2-image.webp'
import bonus3Image from 'assets/images/wellness-download-bonus-3-image.webp'
import deskbookImage from 'assets/images/wellness-download-deskbook-image.webp'

export const WELLNESS_DOWNLOADS_ARCHIVE_URL =
  'https://cdn-uc.ayahpath.com/ayahpath/pdf/islamic-wellness-materials.zip'

export const WELLNESS_DOWNLOADS = [
  {
    titleKey: 'wellnessDownload.deskbookTitle',
    coverImage: deskbookImage,
    bonusNumber: 0,
    fileUrl: 'https://cdn-uc.ayahpath.com/ayahpath/pdf/AP_Wellness_Book.pdf',
  },
  {
    titleKey: 'wellnessDownload.bonus1Title',
    coverImage: bonus1Image,
    bonusNumber: 1,
    fileUrl:
      'https://cdn-uc.ayahpath.com/ayahpath/pdf/How_to_Grow_in_Islam_and_Not_Give_Up.pdf',
  },
  {
    titleKey: 'wellnessDownload.bonus2Title',
    coverImage: bonus2Image,
    bonusNumber: 2,
    fileUrl:
      'https://cdn-uc.ayahpath.com/ayahpath/pdf/Finding_Strength_in_the_Quran.pdf',
  },
  {
    titleKey: 'wellnessDownload.bonus3Title',
    coverImage: bonus3Image,
    bonusNumber: 3,
    fileUrl:
      'https://cdn-uc.ayahpath.com/ayahpath/pdf/AP_The_Ramadan_Recipe_Collection.pdf',
  },
]
